// extracted by mini-css-extract-plugin
module.exports = {"header":"TableHeader_header__3_kQr"};